module.exports = __webpack_public_path__ + "img/专利2.fdbe7ca6.png";